import {persistReducer} from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import {Action, handleAsyncActions} from 'redux/helpers';
import types, {loginReducerKey} from './types';
import {IConnectResponse} from 'types/diplomat/authentication/ConnectResponse';
import {IDiplomatObjectAce} from 'types/diplomat/settings/permissions/DiplomatObjectAce';
import {DiplomatObjectType} from 'types/DiplomatObjectType';

export const loginInitialState = {
   data: {} as IConnectResponse,
   isAuthenticated: false,
   isFetching: false,
   error: null,
   isAdmin: true,
   itemsPermissions: {
      [`${DiplomatObjectType.enum.FOLDER}/-99`]: {},
   } as {[key: string]: IDiplomatObjectAce},
};

const loginReducer = (_state = loginInitialState, action: Action) => {
   const state = handleAsyncActions(_state, action, types);
   switch (action.type) {
      case types.LOGIN.REQUEST:
         return {
            ...state,
            isFetching: true,
            error: null,
         };
      case types.LOGIN.ERROR:
         return {
            ...state,
            isFetching: false,
            isAuthenticated: false,
            error: action.payload,
         };
      case types.LOGIN.SUCCESS:
         return {
            ...state,
            data: action.payload,
            isFetching: false,
            isAuthenticated: true,
            error: null,
         };
      case types.LOGOUT.SUCCESS:
         return {
            ...state,
            data: {},
            isAuthenticated: false,
         };

      case types.FETCH_ITEMS_PERMISSIONS.REQUEST:
         return {
            ...state,
            itemsPermissions: {
               ...state.itemsPermissions,
               [action.payload]: {}, // add empty object to prevent multiple loadings
            },
         };
      case types.FETCH_ITEMS_PERMISSIONS.SUCCESS:
         return {
            ...state,
            itemsPermissions: {
               ...state.itemsPermissions,
               [action.payload.request]: action.payload.response,
            },
         };
      // case types.FETCH_ITEMS_PERMISSIONS.ERROR:
      //    return {
      //       ...state,
      //       itemsPermissions: {
      //          ...state.itemsPermissions,
      //          [action.payload.request]: undefined, // remove object
      //       },
      //    };
      case types.CLEAR_PERMISSIONS_ENTRY: {
         const newItemsPermissions = {...state.itemsPermissions};
         delete newItemsPermissions[action.payload];
         return {
            ...state,
            itemsPermissions: newItemsPermissions,
         };
      }
      default:
         return state;
   }
};

let reducer = loginReducer;
const config = {
   key: loginReducerKey,
   storage: storage,
   blacklist: ['error', 'isFetching', 'itemsPermissions'],
   version: 943,
};
reducer = persistReducer(config, loginReducer) as any;

export default reducer;
